"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPatchResponse = exports.ValidationResponseData = exports.ValidationErrors = exports.ValidationError = exports.ProductUpdates = exports.ProductPatches = exports.ProductUpdate = exports.ProductPatch = exports.PartialProductData = exports.projectProductIdentifier = exports.ListProductsResponse = exports.NonBundleProduct = exports.Product = exports.DbProduct = exports.CommonProduct = exports.ProductProperties = exports.ProductPropertyValue = exports.ComplexProduct = exports.BundleProduct = exports.SimpleProduct = exports.ProductKind = exports.QualifiedProductIdentifier = exports.ScopedProductIdentifier = exports.Articles = exports.Article = exports.Price = exports.Currency = void 0;
const S = __importStar(require("effect/Schema"));
exports.Currency = S.Literal('GBP', 'USD', 'DKK', 'EUR', 'CAD', 'NZD');
exports.Price = S.Struct({
    value: S.Number,
    currency: exports.Currency,
    // Optional value representing a reduced price
    saleValue: S.optional(S.Number),
});
exports.Article = S.Struct({
    thumbnail: S.optional(S.String),
});
exports.Articles = S.Record({ key: S.String, value: exports.Article });
exports.ScopedProductIdentifier = S.Struct({
    canonicalId: S.String,
});
exports.QualifiedProductIdentifier = S.Struct(Object.assign({ tenant: S.String }, exports.ScopedProductIdentifier.fields));
exports.ProductKind = S.Literal('simple', 'bundle', 'complex');
exports.SimpleProduct = S.Struct({
    kind: S.optional(S.Literal('simple')),
    // Map of all article types and their corresponding data contained in the
    // product
    articles: exports.Articles,
    // An identifier to group this product with its "variants"
    groupingCode: S.NullOr(S.String),
    // Lists which of the properties in `properties` are intended to be configurable for other
    // products which share the same groupingCode (its "variants")
    configurableProperties: S.optional(S.Record({
        // Must exactly match a key in `properties`
        key: S.String,
        value: S.Struct({
            // User facing name of this property to display in the front end
            label: S.String,
            // Whether to treat this property as "global" i.e. modifying it will apply the change to all
            // products which have the same property
            isGlobal: S.Boolean,
            // What type is this property, eg. 'finish'
            type: S.Literal('finish', 'dimension', 'custom'),
        }),
    })),
});
exports.BundleProduct = S.Struct({
    kind: S.Literal('bundle'),
    products: S.Array(S.String),
});
const ProductOption = S.Struct({
    id: S.String,
    variants: S.Array(S.Struct({
        value: S.String,
        price: S.Number,
    })),
});
exports.ComplexProduct = S.Struct({
    kind: S.Literal('complex'),
    options: S.Array(ProductOption),
});
exports.ProductPropertyValue = S.Union(S.String, S.Number, S.Boolean, S.Null, S.suspend(() => exports.ProductProperties), S.Array(S.suspend(() => exports.ProductPropertyValue)));
exports.ProductProperties = S.Record({
    key: S.String,
    value: exports.ProductPropertyValue,
});
exports.CommonProduct = S.Struct({
    // Customer-facing product name
    name: S.String,
    // Customer-facing product description
    description: S.String,
    // Product type in our product taxonomy
    productType: S.String,
    // Current availability status for the product
    availability: S.Literal('out-of-stock', 'in-stock', 'suspended'),
    // Flag for products that are discontinued
    discontinued: S.Boolean,
    // Product price & currency
    price: exports.Price,
    // Product Detail Page URL
    productUrl: S.String,
    // Product image URL
    thumbnailUrl: S.String,
    // Additional retailer-specific properties
    // TODO: Some product information is found in here but should be
    // promoted to a first class field of products. Currently, this includes
    // `range`
    properties: exports.ProductProperties,
    features: S.Array(S.String),
    // Product lead time
    leadTime: S.optional(S.Struct({
        // User-facing description
        description: S.String,
        // "Priority" of lead time value (e.g upper bound of lead time estimate)
        // Larger values are "more important"
        priority: S.Number,
    })),
    productPlacement: S.optional(S.Literal('Wall', 'Floor', 'WallAndFloor', 'OtherProduct')),
});
exports.DbProduct = S.extend(S.Struct(Object.assign(Object.assign({}, exports.QualifiedProductIdentifier.fields), exports.CommonProduct.fields)), S.Union(exports.SimpleProduct, exports.BundleProduct, exports.ComplexProduct));
// Product Response type
exports.Product = S.extend(S.Struct(Object.assign(Object.assign({}, exports.ScopedProductIdentifier.fields), exports.CommonProduct.fields)), S.Union(exports.SimpleProduct, exports.BundleProduct, exports.ComplexProduct));
// Specifically for veritas' purposes
exports.NonBundleProduct = S.extend(exports.CommonProduct, exports.SimpleProduct);
exports.ListProductsResponse = S.Struct({
    data: S.Array(exports.Product),
    next: S.Number,
});
const projectProductIdentifier = (product) => ({
    tenant: product.tenant,
    canonicalId: product.canonicalId,
});
exports.projectProductIdentifier = projectProductIdentifier;
// Product patches and update structures
exports.PartialProductData = S.extend(S.partial(exports.CommonProduct), S.Union(S.partial(exports.SimpleProduct), S.partial(exports.BundleProduct), S.partial(exports.ComplexProduct)));
exports.ProductPatch = S.extend(exports.ScopedProductIdentifier, exports.PartialProductData);
exports.ProductUpdate = S.extend(exports.QualifiedProductIdentifier, exports.PartialProductData);
exports.ProductPatches = S.Array(exports.ProductPatch);
exports.ProductUpdates = S.Array(exports.ProductUpdate);
exports.ValidationError = S.Struct({
    productId: S.String,
    reason: S.Literal('Product is missing required facets.', 'Product product type cannot be found in the Product Types Database', 'Product facet does not exist in the database of product type facet definitions', 'Product facet has a value which is not in the allowed list', 'Product properties failed validation'),
    context: S.Record({
        key: S.String,
        value: S.Union(S.String, S.Boolean, S.Record({ key: S.String, value: S.Unknown }), S.Array(S.Unknown)),
    }),
});
exports.ValidationErrors = S.Array(exports.ValidationError);
exports.ValidationResponseData = S.Array(S.Struct({
    rejected: S.Array(exports.ValidationError),
    rejectedInlineErrors: S.Array(S.Unknown),
}));
exports.ProductPatchResponse = S.Struct({
    // products
    updated: S.Array(S.Unknown),
    // products
    upserted: S.Array(S.Unknown),
    ignored: S.Array(S.Struct({
        id: S.String,
        reason: S.String,
        validationErrors: S.String,
    })),
    rejected: S.Array(S.Unknown),
    dryRun: S.optional(S.Boolean),
});
